import {
  parseLista,
  procedimentoNoPeriodo,
} from './functions.js'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros vermelhos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object} selectedEquipe Equipe selecionada.
 * @param {Object|null} mes Mês selecionado no filtro.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedEquipe = null,
  mes = null
) {
  let cadastros_filtrados = cadastros || []

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const exodontias = item.num_taxa_exod != 0

      if (!mes) {
        return exodontias
      }

      const mesesSelecionados = mes.value || []
      const anoSelecionado = mes.nu_ano

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) != 0 &&
          mesesSelecionados.includes(Number(dado.nu_mes)) &&
          Number(dado.nu_ano) === Number(anoSelecionado) &&
          selectedEquipe.ine_esb == dado.nu_ine
        )
      })

      return exodontias && !!registroMes
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const outrosProcedimentos = item.num_taxa_exod == 0

      if (!mes) {
        return outrosProcedimentos
      }

      const lista = [
        ...parseLista(item.dados),
        ...parseLista(item.procedimentos),
      ]

      const registroMes = lista.find((dado) => {
        const mesmaEquipe =
          !dado.nu_ine || selectedEquipe.ine_esb == dado.nu_ine

        return (
          Number(dado.nm) === 0 &&
          procedimentoNoPeriodo(dado, mes) &&
          mesmaEquipe
        )
      })

      return outrosProcedimentos && !!registroMes
    })
  }

  return cadastros_filtrados
}
